import React, { PropsWithChildren, ReactElement } from 'react';

import PropTypes from 'prop-types';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import { TABLE_SIZES } from '../consts';
import getTableTheme from '../helpers/getTableTheme';
import { Themeable } from '../types';

export type TableHeaderGroupProps = StylableComponent<HTMLDivElement> &
  Themeable;

const TableHeaderGroup = ({
  children,
  style = {},
  tableSize,
  ...props
}: PropsWithChildren<TableHeaderGroupProps>): ReactElement => {
  const tableSizeTheme = getTableTheme(tableSize);
  return (
    <tr
      {...props}
      css={[
        {
          width: '100%',
          minWidth: 'fit-content',
          position: 'relative',
          display: 'flex',
          height: tableSizeTheme.rowHeight,
        },
        style,
      ]}
    >
      {children}
    </tr>
  );
};

TableHeaderGroup.propTypes = {
  tableSize: PropTypes.oneOf(Object.values(TABLE_SIZES)),
  style: stylePropType,
  children: PropTypes.any,
};

export default TableHeaderGroup;
